import './_thermostat-control-tab.sass';

import $ from 'jquery';

import Class from '../legacy-class';

import {prettyTimeInterval} from '../../../../utils/time';
import {BottomTab} from '../bottom-tab';
import {ThermometersView_NonReact} from '../state/components/thermometers-view';
import {
    load_description,
    prepare_description,
    short_description_html,
    show_dialog as show_ot_err_dialog,
} from '../opentherm-dialog/opentherm-errcodes-legacy';

import '../../../../mui/dialog';
import '../../../../mui/tumbler';
import {pad0, parseFloatWithComma, prettyFloat} from '../../../../utils/number';
import {escape_html} from '../../../../utils/string';
import {LegacyDevice} from '../../../device/device';

const clamp_temp = (temp) => Math.min(Math.max(temp, -50), 100);

const ModeButton = Class({
    element() {
        return this._element;
    },

    init(title) {
        this._element = $(`
            <div class=\"ui-thermostat-control-mode\">
                <div class=\"ui-thermostat-control-mode-title\">${escape_html(
                    title
                )}</div>
            </div>
        `);

        this._element.on('click', this.notifier('click'));
    },
})
    .implement(Class.EventSource)
    .implement(
        Class.Properties({
            selected: {
                set(selected) {
                    this._element.toggleClass('selected', !!selected);
                },
            },
        })
    );

const ModeButtonSingleChannel = Class(ModeButton, {
    init(title) {
        ModeButtonSingleChannel.superclass.init.apply(this, arguments);

        this._element.append(
            '<div class="ui-thermostat-control-mode-temp">&nbsp;</div>'
        );
    },

    set_target_temp(temp) {
        this._element
            .find('.ui-thermostat-control-mode-temp')
            .html(
                temp != null && typeof temp === 'number'
                    ? escape_html(prettyFloat(temp, 1) + ' °C')
                    : '&nbsp;'
            );
    },
});

const EditableModeButton = Class(ModeButtonSingleChannel, {
    init(title) {
        EditableModeButton.superclass.init.apply(this, arguments);

        this._element.append(`
                <div class="ui-thermostat-control-mode-dec">–</div>
                <div class="ui-thermostat-control-mode-inc">+</div>
            `);

        this._element
            .find('.ui-thermostat-control-mode-dec')
            .on('click', this.notifier('dec'));
        this._element
            .find('.ui-thermostat-control-mode-inc')
            .on('click', this.notifier('inc'));
    },
});

const IdleModeButton = Class(ModeButtonSingleChannel, {
    init() {
        IdleModeButton.superclass.init.apply(this, arguments);
        this._element
            .find('.ui-thermostat-control-mode-temp')
            .after(
                '<div class="ui-thermostat-control-mode-off">Регулирование отключено</div>'
            );
    },

    set_full_off(full_off) {
        this._element
            .toggleClass('full-off', !!full_off)
            .find('.ui-thermostat-control-mode-title')
            .text(full_off ? 'Выключен' : 'Антизаморозка');
    },
});

const Obj = Class({
    element() {},
    init({name, channels, editable}) {
        this._mode_buttons = {};
    },

    set_mode(mode) {
        for (const [btn_mode, button] of Object.entries(this._mode_buttons || {}))
            button.selected(btn_mode === mode);
    },
    set_mode_temps(temps) {},

    set_gate_available(avail) {},
    set_gate(gate) {},

    set_dhw(dhw) {},

    set_tempstep(tempstep) {
        this._tempstep = tempstep;
    },
}).implement(Class.EventSource);

const ObjectSingleChannel = Class(Obj, {
    element() {
        return this._mode_card;
    },

    init({name, channels, editable}) {
        this._mode_card = $(`
            <div class="ui-card" style="flex-basis: 780px; text-align: center;">
                <h1 style="text-align: left">Режим</h1>
               
                <div class="ui-thermostat-control-tumblers">
                    <span class="ui-thermostat-control-tumbler ui-thermostat-control-gate">
                        <div class="ui-thermostat-control-gate-tumbler"></div>
                    </span>
                   
                    <span class="ui-thermostat-control-tumbler ui-thermostat-control-dhw">
                        <div class="ui-thermostat-control-dhw-tumbler"></div>
                    </span>
                </div>
            </div>
        `);

        this._mode_buttons = {
            econom: new ModeButtonSingleChannel('Эконом'),
            comfort: new EditableModeButton('Комфорт'),
            schedule: new ModeButtonSingleChannel('Расписание'),
            idle: new IdleModeButton('Антизаморозка'),
        };

        const tumblers_div = this._mode_card.find('.ui-thermostat-control-tumblers');

        const gate_container = this._mode_card.find('.ui-thermostat-control-gate');
        gate_container.children().tumbler({
            text: {
                off: 'Комнатный термостат',
                on: 'Комнатный термостат',
            },

            change: (event, data) => {
                if (data.from_ui)
                    this.notify('gatechanged', [
                        gate_container.children().tumbler('checked'),
                    ]);
            },
        });

        const dhw_container = this._mode_card.find('.ui-thermostat-control-dhw');
        dhw_container.children().tumbler({
            text: {
                off: 'Горячая вода',
                on: 'Горячая вода',
            },

            change: (event, data) => {
                if (data.from_ui)
                    this.notify('dhwchanged', [
                        dhw_container.children().tumbler('checked'),
                    ]);
            },
        });

        for (const [mode, button] of Object.entries(this._mode_buttons || {})) {
            tumblers_div.before(button.element());
            button.bind('click', () => this.notify('modechanged', [mode]));
        }

        this._mode_buttons.comfort.bind({
            dec: () => this._adjust_comfort_temp(-this._tempstep),
            inc: () => this._adjust_comfort_temp(+this._tempstep),
        });
    },

    _adjust_comfort_temp(delta) {
        if (this._mode_temps == null) return;

        for (const [channel_id, channel_temps] of Object.entries(
            this._mode_temps || {}
        )) {
            if (channel_temps?.comfort != null) {
                // parseFloat and toFixed are for rounding values like 20.1999999999997
                channel_temps.comfort = parseFloat(
                    clamp_temp(channel_temps.comfort + delta).toFixed(1)
                );
                this.notify('tempchanged', [
                    channel_id,
                    'comfort',
                    channel_temps.comfort,
                ]);
            }
        }
        this.set_mode_temps(this._mode_temps);
    },

    set_mode_temps(temps) {
        this._mode_temps = temps;
        for (const [mode, button] of Object.entries(this._mode_buttons || {}))
            for (const channel_temps of Object.values(temps || {})) {
                const temp = channel_temps?.[mode];
                button.set_target_temp(temp);
            }

        for (const channel_temps of Object.values(temps || {}))
            this._mode_buttons.idle.set_full_off(!!channel_temps?.full_off);
    },

    set_gate(gate) {
        this._mode_card
            .find('.ui-thermostat-control-gate-tumbler')
            .tumbler('checked', !!gate);
        this._mode_card
            .find('.ui-thermostat-control-mode')
            .toggleClass('gate-mode', !!gate);
    },

    set_gate_available(avail) {
        this._mode_card
            .find('.ui-thermostat-control-gate')
            .toggleClass('visible', !!avail);
    },

    set_dhw(dhw) {
        this._mode_card
            .find('.ui-thermostat-control-dhw-tumbler')
            .tumbler('checked', !!dhw);
        this._mode_card
            .find('.ui-thermostat-control-dhw')
            .toggleClass('visible', dhw !== null);
    },

    set_schedule_temp(temp) {
        this._mode_buttons.schedule.set_target_temp(temp);
    },
});

const ObjectMultiChannel = Class(Obj, {
    mode_card() {
        return this._mode_card;
    },
    temps_card() {
        return this._temps_card;
    },

    element() {
        return this._mode_card.add(this._temps_card);
    },

    init({name, channels, editable}) {
        let button;
        this._mode_card = $(`
            <div class=\"ui-card\" style=\"flex-basis: 410px; text-align: center;\">
                <div class=\"ui-thermostat-control-modes-title\">
                    <div class=\"ui-thermostat-control-modes-title-object-name\">${name}</div>
                    <h1 style=\"text-align: left\">Режим</h1>
                </div>
            </div>
        `);

        this._temps_card = $(`
            <div class=\"ui-card ui-card-col-1\">
                <h1>Целевая температура</h1>
                
                <table>
                ${channels
                    .map(
                        (ch_spec) =>
                            `<tr class=\"ui-thermostat-control-channel\" channel_id=\"${
                                ch_spec.channel_id
                            }\">
                        <th>${escape_html(ch_spec.name)}</th>
                        <td>
                            <span class=\"ui-thermostat-control-channel-adjust dec\">–</span>
                            <input type=\"text\" style=\"width: 2.5em; font-size: 120%; text-align: right; vertical-align: middle;\"/>
                            <span class=\"ui-thermostat-control-channel-adjust inc\">+</span>
                        </td>
                    </tr>`
                    )
                    .join('')}
                </table>
            </div>
        `);

        this._mode_buttons = {
            econom: new ModeButton('Эконом'),
            comfort: new ModeButton('Комфорт'),
            schedule: new ModeButton('Расписание'),
            idle: new ModeButton('Антизаморозка'),
        };

        for (const [mode, button] of Object.entries(this._mode_buttons || {})) {
            this._mode_card.append(button.element());
            button.bind('click', () => this.notify('modechanged', [mode]));
        }

        this._temps_card
            .find('input')
            .on('focus', (e) => e.target.setSelectionRange(0, e.target.value.length))
            .on('change', (e) => {
                if (this._mode == null) return;
                const input = $(e.target);
                const channel_id = input.closest('tr').attr('channel_id');
                const value = clamp_temp(parseFloatWithComma(input.val()) ?? 20);
                this._set_temp_to_input(input, value);
                if (!this._mode_temps[channel_id]) this._mode_temps[channel_id] = {};
                this._mode_temps[channel_id][this._mode] = value;
                this.notify('tempchanged', [channel_id, this._mode, value]);
            });

        this._temps_card.on('click', '.ui-thermostat-control-channel-adjust', (e) => {
            button = $(e.currentTarget);
            const input = button.siblings('input');
            const delta = button.hasClass('inc') ? this._tempstep : -this._tempstep;
            this._set_temp_to_input(input, parseFloatWithComma(input.val()) + delta);
            input.trigger('change');
        });

        this._tempstep = 1;
    },

    _set_temp_to_input(input, temp) {
        input.val(temp != null ? temp.toFixed(1) : '');
    },

    set_mode(mode) {
        ObjectMultiChannel.superclass.set_mode.apply(this, arguments);
        this._mode = mode;
        this._update_mode_temps();
    },

    set_mode_temps(temps) {
        this._mode_temps = temps || {};
        this._update_mode_temps();
    },

    _update_mode_temps() {
        this._temps_card.find('.ui-thermostat-control-channel').each((i, el) => {
            const temp = this._mode_temps?.[$(el).attr('channel_id')]?.[this._mode];
            this._set_temp_to_input($(el).find('input'), temp);
        });
    },

    set_tempstep(tempstep) {
        this._tempstep = tempstep;
    },
});

const ThermostatControlTab = Class(BottomTab, {
    init(_ui) {
        this._ui = _ui;
        this._element = $(`
            <div class="ui-bottom-tab ui-thermostat-control-tab" tabtitle="термостат" tabicon="ui-icon-tab-temperature"
            role="thermostat-control" style="padding: 0">
                <div class="ui-thermostat-control-tab-content">
                
                    <div class="ui-cards-container" style="max-width: 1024px; width: 100%;">
                        <div class="ui-card ui-thermostat-control-tab-offline">
                            <h1>Нет связи</h1>
                            <div></div>
                        </div>
                    </div>
                
                    <div class="ui-cards-container" style="max-width: 1024px; width: 100%;">
                        <div class="ui-card ui-thermostat-control-tab-fault">
                            <h1>АВАРИЯ КОТЛА</h1>
                            <div class="ui-thermostat-control-tab-fault-details"></div>
                        </div>
                    </div>
                    
                    <div class="ui-cards-container" style="max-width: 1024px; width: 100%;">
                    
                        <div class="ui-card ui-thermostat-control-tab-thermometers" style="flex-basis: 780px">
                            <h1>Температура</h1>
                        </div>
                    </div>
                </div>
            </div>
        `);

        this._thermometers_view = new ThermometersView_NonReact();
        this._element
            .find('.ui-thermostat-control-tab-thermometers')
            .append(this._thermometers_view.element());

        this._element.on('click', '.ot-error-description-link', function (ev) {
            show_ot_err_dialog($(ev.currentTarget));
            return false;
        });

        this._object_widgets = {};

        setInterval(() => this._update_timed_values(), 10e3);

        const on_schedule_temp_update_timeout = () => {
            if (this._device) this._update_schedule_temp(this._device);
            return reschedule_schedule_temp_update();
        };
        const every = 60 * 60 * 1e3; // hour
        const reschedule_schedule_temp_update = () => {
            // +1s to be sure we are in a next hour
            setTimeout(
                () => on_schedule_temp_update_timeout(),
                every - (Date.now() % every) + 1e3
            );
        };
        reschedule_schedule_temp_update();

        this._ui.store.subscribe(() => {
            const selected_id = this._ui.store.getState().devices.selected_id;
            const r_device = this._ui.store
                .getState()
                .devices.items.find((device) => device.id === selected_id);
            const device = new LegacyDevice(this._ui, r_device);
            this._fill(device);
        });
    },

    should_appear_depends_on() {
        return ['capabilities', 'thermostat_enabled', 'access', 'firmware_version'];
    },
    should_appear: function (device) {
        return (
            device?.has_access('view_state') &&
            !device?.supports_thermostat_ext_modes() &&
            (device?.has_capability('has_thermostat') ||
                (device?.has_capability('has_optional_thermostat') &&
                    device?.thermostat_enabled())) &&
            !device?.has_capability('has_z3k_settings')
        );
    },

    _updateSettingsCallback(result) {
        if (!result.ok && result.error !== 'demo_not_allowed') {
            $.mui.mui_dialog.errorbox({
                title: 'Не удалось изменить режим',
                message: `<ul><li>${result.errors.join('</li><li>')}</li></ul>`,
            });
        }
    },

    _showOfflineErrbox() {
        $.mui.mui_dialog.messagebox({
            title: 'Термостат не на связи',
            message: 'Режим будет изменён когда термостат выйдет на связь',
            buttons: [
                {
                    text: 'OK',
                    click: () => {
                        $(this).mui_dialog('close');
                    },
                },
            ],
        });
    },

    _change_mode(object_id, new_mode) {
        if (this._ui.account.is_guest()) return;

        if (this._device?.thermostat_get_mode(object_id) === new_mode) return;

        if (!this._device.online()) this._showOfflineErrbox();

        this._device.thermostat_set_mode(
            object_id,
            new_mode,
            this._updateSettingsCallback.bind(this)
        );
    },

    _change_gate(object_id, new_gate) {
        if (this._ui.account.is_guest()) return;
        if (this._device?.thermostat_get_gate(object_id) === new_gate) return;
        if (!this._device.online()) this._showOfflineErrbox();

        this._device.thermostat_set_gate(
            object_id,
            new_gate,
            this._updateSettingsCallback.bind(this)
        );
    },

    _change_dhw(dhw_enabled) {
        const config = this._device.ot_config();
        if (config == null) return;

        if (dhw_enabled) {
            if (!config.includes('dhw')) config.push('dhw');
        } else {
            if (config.includes('dhw')) config.splice(config.indexOf('dhw'), 1);
        }

        this._device.updateSettings({ot_config: config});

        if (!this._device.online()) this._showOfflineErrbox();
    },

    _change_mode_temp(channel_id, mode, temp) {
        if (this._ui.account.is_guest()) return;

        // @_showOfflineErrbox() if not @_device.online()

        // temps = {}
        // temps[mode] = temp
        // @_device.thermostat_set_mode_temps channel_id, temps, @_updateSettingsCallback.bind @

        this._debounced_change_mode_temps(this._device, channel_id, mode, temp);
    },

    _debounced_change_mode_temps(device, channel_id, mode, temp) {
        if (!this._delayed_mode_temps_per_device)
            this._delayed_mode_temps_per_device = {};

        const setter = {};
        setter[channel_id] = {};
        setter[channel_id][mode] = temp;
        setter[channel_id].full_off = false;
        this._delayed_mode_temps_per_device[device.id()] = $.extend(
            true,
            this._delayed_mode_temps_per_device[device.id()],
            setter
        );

        if (this._delayed_change_mode_temps_timer == null) {
            this._delayed_change_mode_temps_timer = setTimeout(() => {
                this._send_delayed_mode_temps();
                this._delayed_mode_temps_per_device = {};
                this._delayed_change_mode_temps_timer = null;
            }, 2000);
        }
    },

    _send_delayed_mode_temps() {
        for (const [device_id, ch_mode_temps] of Object.entries(
            this._delayed_mode_temps_per_device || {}
        )) {
            const device = this._ui.devices.device(device_id);
            if (device == null) continue;

            device.thermostat_set_multiple_mode_temps(
                ch_mode_temps,
                this._updateSettingsCallback.bind(this)
            );
        }
    },

    _fill(device) {
        this._device = device;

        // if (this._device_bindings != null)
        //     for (let b of this._device_bindings)
        //         b.unbind();
        this._device_bindings?.unbind();
        this._device_bindings = null;

        if (device == null) return;

        this._device_bindings = device.bind({
            l1000_config: () => this._recreate_objects(this._device),
            thermostat_mode: () => this._on_thermostat_mode(this._device),
            thermostat_gate: () => this._on_thermostat_gate(this._device),
            thermostat_mode_multi: () => this._on_thermostat_mode(this._device),
            thermostat_gate_multi: () => this._on_thermostat_gate(this._device),
            thermostat_mode_temps: () => this._on_thermostat_mode_temps(this._device),
            thermostat_mode_temps_multi: () =>
                this._on_thermostat_mode_temps(this._device),
            tempschedule: () => this._update_schedule_temp(this._device),
            timezone: () => this._update_schedule_temp(this._device),
            tempstep: () => this._on_tempstep(this._device),
            last_boiler_state: () => this._on_last_boiler_state(this._device),
            thermostat_gate_available: () =>
                this._on_thermostat_gate_available(this._device),
            online: () => this._on_online(this._device),
            last_connect_time: () => this._update_timed_values(),

            thermometers: () => this._on_thermometers(),

            ot_enabled: () => this._on_ot_enabled_config(this._device),
            ot_config: () => this._on_ot_enabled_config(this._device),
        });

        this._recreate_objects(device);
        this._thermometers_view.device(device);
        this._on_last_boiler_state(this._device);
        this._on_thermostat_gate_available(this._device);
        this._on_online(this._device);
        this._update_timed_values();
        this._on_thermometers();
        this._on_ot_enabled_config(this._device);
    },

    _recreate_objects(device) {
        if (this._object_widgets)
            for (const widget of Object.values(this._object_widgets || {}))
                widget.element().remove();

        const objects = device?.thermostat_get_objects() ?? [];
        this._object_widgets = {};

        for (const obj_spec of objects) {
            const object_class =
                obj_spec.channels.length > 1 ? ObjectMultiChannel : ObjectSingleChannel;

            const widget = new object_class({
                name: obj_spec.name,
                channels: obj_spec.channels,
            });
            this._object_widgets[obj_spec.object_id] = widget;

            widget.bind('modechanged', (mode) =>
                this._change_mode(obj_spec.object_id, mode)
            );
            widget.bind('tempchanged', (channel_id, mode, temp) =>
                this._change_mode_temp(channel_id, mode, temp)
            );
            widget.bind('gatechanged', (gate) =>
                this._change_gate(obj_spec.object_id, gate)
            );
            widget.bind('dhwchanged', (dhw) => this._change_dhw(dhw));
        }

        // @_element.find('.ui-cards-container').children().not('.ui-thermostat-control-tab-thermometers').remove()
        const temps_card = this._element
            .find('.ui-cards-container')
            .find('.ui-thermostat-control-tab-thermometers');
        for (const widget of Object.values(this._object_widgets || {}))
            temps_card.before(widget.element());

        this._on_thermostat_mode(device);
        this._on_thermostat_gate(device);
        this._on_thermostat_mode_temps(device);
        this._update_schedule_temp(this._device);
        this._on_tempstep(device);
    },

    _on_thermostat_mode(device) {
        for (const [object_id, widget] of Object.entries(this._object_widgets || {}))
            widget.set_mode(device.thermostat_get_mode(object_id));
    },

    _on_thermostat_gate(device) {
        for (const [object_id, widget] of Object.entries(this._object_widgets || {}))
            widget.set_gate(device.thermostat_get_gate(object_id));
    },

    _on_thermostat_mode_temps(device) {
        const temps = device.thermostat_get_all_mode_temps();
        for (const widget of Object.values(this._object_widgets || {}))
            widget.set_mode_temps(temps);
    },

    _update_schedule_temp(device) {
        if (!device.is_multi_thermostat()) {
            const schedule = device.tempschedule();
            const tz = device.timezone() ?? 3;
            const widget = this._object_widgets[0];
            widget?.set_schedule_temp(this._current_schedule_temp(schedule, tz));
        }
    },

    _on_tempstep(device) {
        for (const widget of Object.values(this._object_widgets || {}))
            widget.set_tempstep(device.tempstep());
    },

    _on_last_boiler_state(device) {
        const lbs = device?.last_boiler_state();
        const fail = lbs?.fail ?? false;
        const ot_state = lbs?.ot ?? {};

        this._element
            .find('.ui-thermostat-control-tab-fault')
            .toggleClass('visible', fail);

        const descr = [];

        if (ot_state.ff) {
            if (ot_state.ff.c !== 0) {
                descr.push(`<p>Код ошибки E${pad0(ot_state.ff.c, 2)}</p>`);
                if (device.ot_boiler_type()) {
                    const dfr = load_description(
                        this._ui,
                        device.ot_boiler_type(),
                        ot_state.ff.c
                    )
                        .then(prepare_description)
                        .then(short_description_html);

                    switch (dfr.state()) {
                        case 'pending':
                            descr.push('<p role="opentherm_error_description"></p>');
                            dfr.done((html) => {
                                this._element
                                    .find(
                                        '.ui-thermostat-control-tab-fault-details [role="opentherm_error_description"]'
                                    )
                                    .html(html);
                            });
                            break;
                        case 'resolved':
                            dfr.done((html) => descr.push(html));
                            break;
                    }
                }
            }

            if (ot_state.ff.f) {
                if (ot_state.ff.f.includes('sr'))
                    descr.push(
                        '<p title="Service request">Необходимо обслуживание</p>'
                    );
                if (ot_state.ff.f.includes('lr'))
                    descr.push('<p title="Lockout-reset">Требуется ручной сброс</p>');
                if (ot_state.ff.f.includes('wp'))
                    descr.push(
                        '<p title="Low water pressure">Низкое давление воды</p>'
                    );
                if (ot_state.ff.f.includes('gf'))
                    descr.push('<p title="Gas/flame fault">Сбой газа/горелки</p>');
                if (ot_state.ff.f.includes('ap'))
                    descr.push(
                        '<p title="Air pressure fault">Сбой давления воздуха</p>'
                    );
                if (ot_state.ff.f.includes('wot'))
                    descr.push('<p title="Water over-temperature">Перегрев воды</p>');
            }
        }

        this._element
            .find('.ui-thermostat-control-tab-fault-details')
            .html(descr.join(''));
    },

    _on_thermostat_gate_available(device) {
        const avail = device.thermostat_gate_available();
        return (() => {
            const result = [];
            for (const obj_id of Object.keys(this._object_widgets || {})) {
                const widget = this._object_widgets[obj_id];
                result.push(widget.set_gate_available(avail));
            }
            return result;
        })();
    },

    _on_ot_enabled_config(device) {
        for (const widget of Object.values(this._object_widgets || {}))
            widget.set_dhw(
                device.ot_enabled() && device.ot_config() != null
                    ? device.ot_config().includes('dhw')
                    : null
            );
    },

    _on_online(device) {
        this._element
            .find('.ui-thermostat-control-tab-offline')
            .toggleClass('visible', !device.online());
    },

    _update_timed_values() {
        const last_connect_time = this._device?.last_connect_time();

        this._element
            .find('.ui-thermostat-control-tab-offline div')
            .html(
                last_connect_time != null
                    ? prettyTimeInterval(
                          parseInt(
                              (new Date().getTime() - last_connect_time * 1000) / 1e3,
                              10
                          ),
                          {short: false, nbsp: false, accusative: true}
                      )
                    : ''
            );
    },

    _on_thermometers() {
        const hide =
            this._device?.has_capability('has_optional_thermostat') &&
            this._device.active_thermometers().length === 0;
        this._element
            .find('.ui-thermostat-control-tab-thermometers')
            .toggleClass('hidden', hide);
    },

    _current_schedule_temp(schedule, tz, browser_time = new Date()) {
        const device_time = new Date(
            browser_time.getTime() +
                browser_time.getTimezoneOffset() * 60 * 1e3 +
                tz * 60 * 60 * 1e3
        );
        const day = (device_time.getDay() + 6) % 7;
        const hour = device_time.getHours();

        return schedule?.week?.[day]?.[hour];
    },
}).implement(
    Class.Properties({
        device: {
            set(device) {
                if (this._device === device) return;

                this._fill(device);
            },
        },
    })
);

export default ThermostatControlTab;

ThermostatControlTab.should_appear_depends_on =
    ThermostatControlTab.prototype.should_appear_depends_on();
ThermostatControlTab.should_appear = ThermostatControlTab.prototype.should_appear;
